/* eslint-disable max-len */
import { gql } from "graphql-tag";

export const userProfileQuery = gql`
  query UserProfile($id: ID!) {
    userProfile(id: $id) {
      firstName
      lastName
      title
      dateOfBirth
      gender
      pronouns
      customPronouns
      race
      ethnicity
      citizenship
      currentAddress {
        id
        address1
        address2
        city
        state
        zip
      }
      mailingAddress {
        id
        address1
        address2
        city
        state
        zip
      }
      addresses {
        id
        address1
        address2
        city
        state
        zip
      }
      emails {
        id
        address
      }
      phones {
        id
        number
      }
    }
  }
`;

export const updateUserProfileMutation = gql`
  mutation UpdateUserProfile($id: ID!, $title: String, $dateOfBirth: String, $gender: Genders, $pronouns: Pronouns, $customPronouns: String, $race: Races, $ethnicity: Ethnicities, $citizenship: Citizenships) {
    updateUserProfile(id: $id, title: $title, dateOfBirth: $dateOfBirth, gender: $gender, pronouns: $pronouns, customPronouns: $customPronouns, race: $race, ethnicity: $ethnicity, citizenship: $citizenship) {
      id
    }
  }
`;

export const addUserProfileAddressMutation = gql`
  mutation AddUserProfileAddress($setAsCurrentAddress: Boolean!, $setAsMailingAddress: Boolean!, $address: UserProfileAddressInput!) {
    addUserProfileAddress(setAsCurrentAddress: $setAsCurrentAddress, setAsMailingAddress: $setAsMailingAddress, address: $address) {
      id
      address1
      address2
      city
      state
      zip
    }
  }
`;

export const editUserProfileAddressMutation = gql`
  mutation EditUserProfileAddress($setAsCurrentAddress: Boolean!, $setAsMailingAddress: Boolean!, $address: UserProfileAddressInput!) {
    editUserProfileAddress(setAsCurrentAddress: $setAsCurrentAddress, setAsMailingAddress: $setAsMailingAddress, address: $address) {
      id
      address1
      address2
      city
      state
      zip
    }
  }
`;

export const deleteUserProfileAddressMutation = gql`
  mutation DeleteUserProfileAddress($id: ID!) {
    deleteUserProfileAddress(id: $id) {
      id
    }
  }
`;

export const setAsUserProfileCurrentAddressMutation = gql`
  mutation SetAsUserProfileCurrentAddress($id: ID!) {
    setAsUserProfileCurrentAddress(id: $id) {
      id
    }
  }
`;

export const setAsUserProfileMailingAddressMutation = gql`
  mutation SetAsUserProfileMailingAddress($id: ID!) {
    setAsUserProfileMailingAddress(id: $id) {
      id
    }
  }
`;
